<template>
  <div>
    <div class="row">
      <div v-if="search" class="col-md-8 d-flex">
        <b-form-group id="input-group-1" label="Pesquisar" label-for="filter">
          <b-input-group>
            <b-form-input id="filter" v-model="filter" type="text" placeholder="Pesquisar..."></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="onFilter">Limpar</b-button>
            </b-input-group-append>
          </b-input-group>
          <b-form-group v-if="searchItemsName" :label="searchItemsName">
            <b-form-select v-model="searchItem" :options="searchItems"></b-form-select>
          </b-form-group>
        </b-form-group>
      </div>
      <div class="col d-flex align-items-center justify-content-end">
        <button class="btn btn-primary" @click="$refs.btnexport.$el.click()">
          Exportar Excel
          <vue-excel-xlsx
            ref="btnexport" 
            style="display: none" 
            :data="rowData"
            :columns="columnData"
            :filename="sheetName"
            sheetname="dados">
          </vue-excel-xlsx>
        </button>
      </div>
    </div>
    <b-table
      striped hover :items="tableItems" :fields="tablesFields" :current-page="currentPage" :per-page="perPage"
      :filter="filter" :filter-included-fields="filterOn" show-empty>
      <template v-slot:append> </template>
      <template v-slot:empty="scope"> Nenhum registro encontrado! </template>
      <template v-for="(_, slotName) of $scopedSlots" v-slot:[slotName]="scope">
        <slot :name="slotName" v-bind="scope" />
      </template>
      <template v-slot:cell(actionsInternacao)="row">
        <button v-b-tooltip.hover :title="(row.item.internado?'Encerrar':'Adicionar')+' Internação'" type="button" class="btn btn-light" @click="alterarInternacao(row.item)">
          <i v-if="row.item.internado" class="uil uil-times-circle"></i>
          <i v-else class="uil uil-check"></i>
        </button>
      </template>
      <template v-slot:cell(actions)="row">
        <div v-if="!hiddenButtons" class="btn-group mb-2">
          <button
v-if="!(usuario.tipo == 'verificador')" v-b-tooltip.hover title="Deletar" type="button" class="btn btn-light"
            @click="modalDelete(row.item._id)">
            <i class="uil uil-trash-alt"></i>
          </button>
          <button v-if="!(usuario.tipo == 'verificador')" v-b-tooltip.hover title="Editar" type="button" class="btn btn-light" @click="modalEdit(row.item)">
            <i class="uil uil-edit-alt"></i>
          </button>
          <button
v-if="comprovante" v-b-tooltip.hover title="Comprovante" type="button" class="btn btn-light"
            @click="getComprovante(row.item)">
            <i class="uil uil-clipboard"></i>
          </button>
        </div>
      </template>
      <template v-slot:cell(data)="row">
        {{ formatDate(row.item.data) }}
      </template>
      <template v-slot:cell(date)="row">
        {{ formatDate(row.item.date) }}
      </template>
      <template v-slot:cell(internado)="row">
        {{ row.item.internado?"Sim":"Não" }}
      </template>
      <template v-slot:cell(telefones)="row">
        {{ row.item.telefones }}
      </template>
      <template v-slot:cell(aberto)="row">
        {{ row.item.aberto ? 'Aberto' : "Fechado" }}
      </template>
      <template v-slot:cell(vencimento)="row">
        {{ formatDate(row.item.vencimento) !== "Invalid date" ?
          formatDate(row.item.vencimento) :
          row.item.vencimento }}
      </template>
      <template v-slot:cell(cliente.nome)="row">
        {{ row.item.cliente ? row.item.cliente.nome :
          row.item.carnet.cliente ? row.item.carnet.cliente.nome : ""
        }}
      </template>
      <template v-slot:cell(semConsumo)="row">
        {{row.item.semConsumo?row.item.semConsumo.length:0}}
      </template>
      <template v-slot:cell(setSemConsumo)="row">
        <button v-b-tooltip.hover title="Detalhes Sem Consumo" type="button" class="btn btn-light" @click="setSemConsumo(row.item.semConsumo)">
            <i class="uil uil-clipboard"></i>
          </button>
      </template>
    </b-table>
    <b-pagination v-model="currentPage" size="md" :total-rows="rows" :per-page="perPage"></b-pagination>
    <b-modal v-model="modal" title="Aviso" title-class="font-18">
      <p>Tem certeza que deseja excluir este registro?</p>
      <template v-slot:modal-footer>
        <b-button variant="light" @click="modal = false">Não</b-button>
        <b-button variant="danger" @click="handleDelete">Sim</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import moment from 'moment'
import VueExcelXlsx from 'vue-excel-xlsx'
import Vue from 'vue'

Vue.use(VueExcelXlsx)

export default {
  props: ['tableItems','totalRows' ,'tablesFields', 'search', 'filterFields', 'comprovante', 'searchItems', 'searchItemsName', 'hiddenButtons', 'sheetName', 'perPageManual'],
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      modal: false,
      filter: '',
      itemId: '',
      filterOn: [],
      searchItem: '',
      usuario: this.$store.state.auth.currentUser.usuario,
      rowData: [],
      columnData: []
    }
  },
  computed: {
    rows() {
      if(this.totalRows)
        return this.totalRows
      return this.tableItems.length
    },
  },

  watch: {
    // filter() {
    //   this.onFilter()
    // },
    searchItem() {
      this.$emit('handleGet', this.searchItem ? this.searchItem._id : this.searchItem)
    },
    
    tableItems: {
      immediate: true, // Para chamar a função no momento da montagem
      handler(newTableItems) {
        this.columnData = []
        this.rowData = []
        this.extractColumnsAndData(newTableItems);
      }
    },
  },
  mounted() {
    if (this.filterFields)
      this.filterOn = this.filterFields
    if(this.perPageManual)
      this.perPage = this.perPageManual
    console.log(this.perPageManual)
  },

  methods: {
    setSemConsumo(SemConsumo){
      this.$emit('setSemConsumo', SemConsumo)
    },
    onPaginate(){
      this.$emit('onPaginate', {currentPage:this.currentPage,
        perPage:this.perPage,})
    },
    extractColumnsAndData(tableItems) {
      // Extrair colunas com base na primeira entrada
      const firstItem = tableItems[0];
      for (const key in firstItem) {
        this.columnData.push({
          label: key,
          field: key,
        });
      }

      // Extrair dados com base em todas as entradas
      tableItems.forEach(item => {
        const rowData = {};
        for (const column of this.columnData) {
          rowData[column.field] = item[column.field] || '';
        }
        this.rowData.push(rowData);
      });
    },
    getComprovante(comprovante) {
      this.$emit('getComprovante', comprovante)
    },
    onFilter() {
      this.$emit('onFilter', this.filter)
    },
    alterarInternacao(cliente){
      this.$emit('alterarInternacao', cliente)
    },
    modalDelete(item) {
      this.modal = true
      this.itemId = item
    },

    handleDelete() {
      this.$emit('onDelete', this.itemId)
      this.itemId = null
      this.modal = false
    },
    formatDate(date) {
      if (date)
        return moment(date).format("DD/MM/YYYY")
    },
    modalEdit(item) {
      this.$emit('onEdit', item)
    },
  },
}
</script>

<style></style>
